<template>
  <div class="search-inputs">
    <div class="form-group search-location">
      <div>
        <input
            type="text"
            :placeholder="trans('booking-process.location_search.pickup_location')"
            :class="['form-control real-input', {'mobile-form-control': screenType === 'mobile'}]"
            ref="locationSearch"
            tabindex="1"
            v-model="query"
            data-cy="search-location"
            @focus="wasFocused()"
            @blur="wasBlurred()"
            :disabled="locked"
        />
      </div>
      <script type="text/template" id="location-search-template">
        <div class="location-search-dropdown">
          <div class="aa-dataset-d1"></div>
          <button type="button" id="show-more-locations-button">{{ trans('greenmotion.home.show_more_options') }}</button>
        </div>
      </script>
    </div>
    <div v-if="dropoffLocations.length && !disableDropoffDropdown" class="mb-4">
      <div class="form-group search-location with-navigation-icon mb-0">
        <div>
          <label for="dropofflocation">{{ trans('booking-process.location_search.dropoff_location') }}</label>
          <input
              type="text"
              :placeholder="trans('booking-process.location_search.choose_location')"
              :class="['form-control dropoff-location', {'mobile-form-control': screenType === 'mobile'}]"
              tabindex="2"
              id="dropofflocation"
              :value="dropoffLocationName"
              readonly
              @focus="dropoffSuggestions = true"
              @blur="hideDropoffSuggestions"
          />
        </div>
      </div>
      <div class="dropoff-dropdown-container">
        <div class="location-search-dropdown dropoff-dropdown" v-if="dropoffSuggestions">
          <div class="aa-dataset-d1">
                        <span class="aa-suggestions">
                            <div
                                v-for="location in filteredDropoffLocations"
                                :key="location.id"
                                class="aa-suggestion"
                                @click="updateDropoffLocation(location)"
                                :class="{ active: dropoffLocationName === location.name }"
                            >
                                <div class="aa-suggestion-location">
                                    <span>{{ location.name }}</span>
                                </div>
                                <div class="aa-suggestion-extra-details">
                                    <span>{{ location.country.name }}</span>
                                </div>
                            </div>
                        </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from '../../../bus';
import dropoff from 'greenmotion-shared/mixins/dropoff';
import LocationSearch from 'greenmotion-shared/mixins/LocationSearch';
import lang from '../../../shared/mixins/lang';
import autocomplete from 'autocomplete.js';
import algoliasearch from 'algoliasearch';
import {mapGetters} from "vuex";

export default {
  name: 'LocationSearch',

  mixins: [LocationSearch, dropoff, lang],

  props: {
    disableDropoffDropdown: Boolean,
    locked: Boolean,
  },

  data() {
    return {
      hits: 3,
      query: '',
      dropoffSuggestions: false,
      pickupLocationHasFocus: false,
    };
  },

  computed: {
    filteredDropoffLocations() {
      return this.dropoffLocations;
    },
    locale() {
      if(window.greenmotion && window.greenmotion.locale){
        return window.greenmotion.locale || 'en';
      }
      return 'en';
    },
    noResultsLabel() {
      return this.trans('booking-process.search.location_no_results_label');
    },
    pickupLocationId() {
      return null;
    },
    isIe() {
      return false;
    },
    searchOptions() {
      return {
        appId: ALGOLIA_APP_ID,
        apiKey: ALGOLIA_READ_KEY,
        prefix: ALGOLIA_PREFIX,
      };
    },
    searchProviders() {
      return window.greenmotion.search.providers;
    },
    dropoffLocationName() {
      if (this.$parent.dropoffLocation) {
        if (this.$parent.dropoffLocation.localisations !== undefined && this.$parent.dropoffLocation.localisations[this.locale]) {
          return this.$parent.dropoffLocation.localisations[this.locale].name;
        }
        else {
          return this.$parent.dropoffLocation.name;
        }
      }
    },
    algoliaFilters() {
      const locationSources = LocationSearch.computed.algoliaFilters.call(this);

      // Hide disabled locations
      let filtered = locationSources + ' AND is_active:true';

      if (window.greenmotion.franchiseCountry) {
        return filtered + ' AND country_id:' + window.greenmotion.franchiseCountry;
      }
      return filtered;
    },
    ...mapGetters({
      screenType: 'getScreenType',
    })
  },

  methods: {
    wasFocused() {
      this.pickupLocationHasFocus = true;
    },
    wasBlurred() {
      this.pickupLocationHasFocus = false;
    },
    updateDropoffLocation(location) {
      if (location.localisations[this.locale]) {
        location.name = location.localisations[this.locale].name;
      }

      this.$store.dispatch('setDropoffLocation', location);
    },
    hideDropoffSuggestions() {
      setTimeout(() => {
        this.dropoffSuggestions = false;
      }, 200);
    },
    loadLocationsIfTheyAlreadyExist() {
      if (this.$parent.pickupLocation) {
        this.query = this.$parent.pickupLocation.name;
        this.dropoffLocations = [this.dropoffLocationName];
      }
    },
    ShowMoreLocations() {
      this.hits = 999;

      this.autocomplete.autocomplete.destroy();

      var client = algoliasearch(this.searchOptions.appId, this.searchOptions.apiKey);
      var index = client.initIndex(`${this.searchOptions.prefix}locations`);

      this.autocomplete = autocomplete(
        this.$refs.locationSearch,
        {
            autoselect: true,
            autoselectOnBlur: true,
            templates: {
                dropdownMenu: '#location-search-template',
                empty: '<div>'+ this.noResultsLabel +'</div>',
            },
        },
        [
            {
                source: autocomplete.sources.hits(index, { hitsPerPage: this.hits, filters: this.algoliaFilters }),
                name: 'd1',
                displayKey: 'name',
                templates: {
                    suggestion: suggestion => {
                        return `
                              <div class="aa-suggestion-location">
                                <span>${this.highlightQuery(suggestion)}</span>
                              </div>
                              <div class="aa-suggestion-extra-details">
                                <span>${this.parseLocationDetails(suggestion)}</span>
                              </div>
                            `;
                    },
                },
            },
        ]
      ).on('autocomplete:selected', (event, suggestion, dataset) => {
        this.$store.dispatch('setPickupLocation', suggestion);
        this.$emit('locationSearch.pickUpLocation', suggestion);
        this.$emit('input', suggestion);
      });

      this.autocomplete.autocomplete.open();
      this.$refs.locationSearch.focus();
      document.getElementById('show-more-locations-button').style.display = 'none';
    }
  },

  mounted() {
    this.$on('locationSearch.pickUpLocation', suggestion => {
      this.$refs.locationSearch.blur();
      if (suggestion.localisations[this.locale]) {
        this.query = suggestion.localisations[this.locale].name;
      }
      else {
        this.query = suggestion.name;
      }
    });

    Bus.$on('updateQueryLocation', () => {
      this.query = this.$parent.pickupLocation.name;
    })

    this.loadLocationsIfTheyAlreadyExist();

    document.addEventListener('click', e => {
      if (e.target.id == 'show-more-locations-button') {
        this.ShowMoreLocations();
      }
    })
  },
};
</script>

<style lang="scss">
body.greenmotion-refresh {
  .booking-form {
    .select-location {
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 0px;
    }
    .search-location {
      position: relative;
    }
    .dropoff-location[readonly] {
      background-color: #fff;
    }
    .dropoff-dropdown-container {
      position: relative;
      .dropoff-dropdown {
        position: absolute;
        z-index: 100;
        width: 100%;
        max-height: calc(64px * 3);
        overflow: scroll;
      }
    }
    .search-location {
      .algolia-autocomplete,
      &.with-navigation-icon {
        &:before {
          position: absolute;
          top: 0;
          left: 0;
          content: '';
          width: 25px;
          height: 100%;
          background-image: url(/images/svgs/location-arrow.svg);
          background-position: center;
          background-repeat: no-repeat;
          z-index: 99;
          margin-left: 6px;
        }
      }

      &.with-navigation-icon {
        &:before {
          height: 44px;
          bottom: 0;
          top: auto;
        }
      }
    }

    .algolia-autocomplete {
      width: 100%;
    }

    .search-inputs {
      input {
        text-indent: 30px;
      }

      select {
        text-indent: 22px;
      }

      //Start dummy/duplicate input fix for floating label
      .floating-label {
        margin-top: -2rem;

        label {
          line-height: 2.3;
          margin-left: 30px;

          &.not-empty,
          &.focus {
            margin-left: 0px;
          }
        }
      }

      .floating-label input:not(:placeholder-shown) + label,
      .floating-label input:focus + label,
      .floating-label input + label.focus {
        margin-left: 0;
      }

      input.genuine-input::-webkit-input-placeholder {
        opacity: 0 !important;
        transition: inherit;
      }

      input.genuine-input:focus::-webkit-input-placeholder {
        opacity: 1;
      }

      //End dummy/duplicate input fix for floating label
    }

    @media only screen and (max-device-width: 400px) {
      .search-inputs {
        select {
          text-indent: 6px;
        }
      }
    }

    .aa-dropdown-menu {
      width: 100%;
      transform: translateY(-10px);
    }

    .aa-suggestion {
      border-bottom: 2px #e1e1e1 solid;

      &:last-child {
        border: 0px;
      }

      &:hover,
      &.active,
      &.aa-cursor {
        background-color: var(--primary);
        color: var(--white);

        em {
          color: var(--gray-300);
        }
      }
    }

    .search-location {
      select.form-control {
        border-top: 0px;
        border-left: 0px;
        border-right: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        height: 54px;
        margin-top: -8px;
      }
    }

    .location-search-dropdown {
      width: 100%;

      background-color: var(--white);
      border: var(--primary) solid;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      overflow: hidden;

      $large-margin: 15px;
      $small-margin: 10px;

      em {
        color: var(--primary);
        font-style: normal;
      }

      .aa-suggestion-location {
        width: 100%;
        padding: $small-margin $large-margin 0 $large-margin;
        font-weight: bold;
      }

      .aa-suggestion-extra-details {
        width: 100%;
        padding: 0 $large-margin $small-margin $large-margin;
      }
    }

    .aa-empty {
      width: 100%;
      background-color: var(--white);
      border: var(--primary) solid;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      padding: 10px 15px 10px 15px;
      overflow: hidden;
      margin-top: -7px;
    }

    #show-more-locations-button {
      color: var(--white);
      font-weight: 400;
      font-size: 18px;
      background-color: var(--primary);
      width: 100%;
      border: none;
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }
  }
}
</style>